export class Endereco {
  rua: string;
  bairro: string;
  cep: string;
  numero: string;
  cidade: string;
  uf: string;

  constructor(
    rua = "",
    bairro = "",
    cep = "",
    numero = "",
    cidade = "",
    uf = ""
  ) {
    this.rua = rua;
    this.bairro = bairro;
    this.cep = cep;
    this.numero = numero;
    this.cidade = cidade;
    this.uf = uf;
  }
}
